import React from 'react';
import { Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import Messages from 'i18n/messages/common';

const FormSaveButton = (props) => {
  const { text, style, ...restProps } = props;
  return (
    <Button
      type='primary'
      style={{ borderRadius: '4px', ...style }}
      icon={<SaveOutlined />}
      {...restProps}
    >
      <span>{text || <FormattedMessage {...Messages.saveBtn} />}</span>
    </Button>
  );
};

export default FormSaveButton;
